import React, { useState, useContext, useEffect, useRef, useMemo } from 'react';
import { useHistory } from 'react-router';
import { trash } from 'ionicons/icons';
import { v4 as uuidv4 } from 'uuid';
import { IonButton, IonIcon } from '@ionic/react';
import cbbTeams from '../../data/Sports/CBB.json';
import mlbTeams from '../../data/Sports/MLB.json';
import nbaTeams from '../../data/Sports/NBA.json';
import cfbTeams from '../../data/Sports/NCAAF.json';
import nflTeams from '../../data/Sports/NFL.json';
import nhlTeams from '../../data/Sports/NHL.json';
import nwslTeams from '../../data/Sports/NWSL.json';
import soccerTeams from '../../data/Sports/SOCCER.json';
import wnbaTeams from '../../data/Sports/WNBA.json';
import { AppContext, AppDispatchContext, ACTIONS as APP_CTX_ACTIONS } from '../../global/AppContext';
import { rejectFight, TAKEOUT_TYPES } from '../../global/request/bet';
import useTeamsUIConfig from '../../global/useTeamsUIConfig';
import { AuthContext } from '../authentication/AuthContext';
import TakerError from '../fight/takerFightProcess/TakerError';
import TakerFightProcess from '../fight/takerFightProcess/TakerFightProcess';
import BaseFightCard from '../fightCardV2.1.0/BaseFightCard';
import BetDetailsModal from '../home/BetDetailsModal';
import { LiveFightsLoader } from '../skeletalLoaders/SkeletalLoaders';
import ViewDetailsModal from './ViewDetailsModal';
import '../../styles/profile/LiveFightCard.scss';

/**
 *
 * @param {Object} props
 * @param {Object} props.fight The fight data to be displayed.
 * @param {string} props.fight.chosenTeam The chosen team for the fight.
 * @param {string} props.fight.challengerTeam The challenger team for the fight.
 * @param {string} props.fight.challengerName The challenger name for the fight.
 * @param {string} props.fight.msg The message for the fight.
 * @param {string} props.fight.time The time for the fight.
 * @param {boolean} props.fight.pending Whether the fight is pending this users' response. If false then it is an outgoing fight pending another person's response.
 * @param {boolean} props.isAccepted Whether the fight is accepted or not.
 * @returns
 */

function LiveFightCard({
  fight: {
    bet,
    makerTeam,
    takerTeam,
    makerTeamColor,
    takerTeamColor,
    makerName,
    takerName,
    makerOutcomePhrase,
    takerOutcomePhrase,
    sport,
    // restaurantId
    // msg,
    time,
    pending,
    fightId,
    // address,
  },
  onFightAction,
  profileName,
  isAccepted,
  // onViewFight,
  onAcceptFight,
}) {
  const authCtx = useContext(AuthContext);
  const appCtx = useContext(AppContext);
  const appDispatchCtx = useContext(AppDispatchContext);
  const bearerToken = authCtx.tokens.idToken;

  const isMaker = makerName === profileName;
  const fightModalRef = useRef();
  const [activeBet, setActiveBet] = useState(null);
  const [isBetDetailsOpen, setIsBetDetailsOpen] = useState(false);
  const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);
  const [modalAnimationClass, setModalAnimationClass] = useState('modal-slide-in');
  const cardRef = useRef();
  // eslint-disable-next-line no-unused-vars
  const [reload, specialsTeamsConfig, loading, err] = useTeamsUIConfig();
  const [isPickVenuePopupOpen, setIsPickVenuePopupOpen] = useState(false);
  const [onSelectVenue, setOnSelectVenue] = useState(null);
  const history = useHistory();
  const optionalTakerVenue = useMemo(() => {
    if (bet.takeoutType === TAKEOUT_TYPES.DELIVERY && appCtx.restaurant) {
      return {
        id: appCtx.restaurant.id,
        name: appCtx.restaurant.name,
        takeoutType: appCtx.isDelivery ? TAKEOUT_TYPES.DELIVERY : TAKEOUT_TYPES.IN_PERSON,
      };
    }
    return null;
  }, [bet.takeoutType, appCtx.restaurant, appCtx.isDelivery]);
  // eslint-disable-next-line no-unused-vars
  const restaurantItemKeys = useMemo(() => {
    return bet.restaurantItems.map(() => uuidv4());
  }, [bet.restaurantItems]);
  const [allTeams, setAllTeams] = useState([
    ...nbaTeams,
    ...nflTeams,
    ...cfbTeams,
    ...nhlTeams,
    ...mlbTeams,
    ...soccerTeams,
    ...cbbTeams,
    ...wnbaTeams,
    ...nwslTeams,
  ]);
  useEffect(() => {
    setAllTeams(prevTeams => [...prevTeams, ...specialsTeamsConfig]);
  }, [specialsTeamsConfig]);

  if (!profileName) {
    return <LiveFightsLoader />;
  }

  const findTeamAcronym = teamName => {
    let foundTeam = allTeams.find(team => team.name === teamName);
    if (!foundTeam) {
      foundTeam = specialsTeamsConfig.find(team => team.name === teamName);
    }
    if (!foundTeam) {
      foundTeam = specialsTeamsConfig.find(team => team.acronym === teamName);
    }
    if (foundTeam) {
      return foundTeam.acronym;
    }
    if (teamName.split(' ')[1]) {
      return teamName.split(' ')[1];
    }
    return teamName;
  };

  // const formatPhrase = () => {
  //   const phrase = profileName === makerName ? makerOutcomePhrase : takerOutcomePhrase;
  //   const teamName = profileName === makerName ? bet.makerOutcomeTeam : bet.takerOutcomeTeam;
  //   const teamAcronym = profileName === makerName ? findTeamAcronym(makerTeam) : findTeamAcronym(takerTeam);
  //   let outcomePhrase = phrase.replace(teamName, 'teamAcronym');
  //   if (sport === 'Specials') {
  //     const outcomes = ['wins', 'win', 'first', 'next'];
  //     let specialPhrase = teamName;
  //     // eslint-disable-next-line no-plusplus
  //     for (let i = 0; i < outcomes.length; i++) {
  //       const outcome = outcomes[i];
  //       if (teamName.includes(outcome)) {
  //         const specialOutcome = teamName.split(outcome)[1];
  //         specialPhrase = `${teamAcronym} ${outcome} ${specialOutcome.trim()}`;
  //         break;
  //       }
  //     }
  //     outcomePhrase = specialPhrase;
  //   }
  //   return outcomePhrase;
  // };

  // const formatMsg = msgPhrase => {
  //   const outcome = formatPhrase();
  //   const outcomephrase = profileName === makerName ? makerOutcomePhrase : takerOutcomePhrase;
  //   msgPhrase = msgPhrase.replace(outcomephrase, outcome);
  //   msgPhrase = msgPhrase.replace('GAMELINE1', '');
  //   msg = msgPhrase;
  //   return msgPhrase;
  // };

  const findTeamColor = (teamName, teamColor) => {
    const DEFAULT_COLOR = teamColor;
    let foundTeam = allTeams.find(team => team.name === teamName && team.sport === sport);
    if (!foundTeam) {
      foundTeam = specialsTeamsConfig.find(team => team.name === teamName);
    }
    if (!foundTeam) {
      const teamNameAcr = findTeamAcronym(teamName);
      foundTeam = allTeams.find(team => team.acronym === teamNameAcr && team.sport === sport);
      if (!foundTeam) {
        foundTeam = specialsTeamsConfig.find(team => team.acronym === teamNameAcr);
      }
    }
    const color = foundTeam ? foundTeam.color : DEFAULT_COLOR;
    return color;
  };

  const makerItems = bet.restaurantItems?.filter(item => item.maker_item) || [];
  // takerItems are different if modified, else are the original maker items
  const takerItems =
    (bet.restaurantItems?.filter(item => item.taker_item).length
      ? bet.restaurantItems.filter(item => item.taker_item)
      : bet.restaurantItems?.filter(item => item.maker_item)) || [];

  const getGamePanelData = () => {
    // Maker = right side; taker = left side
    if (isMaker) {
      return {
        sportLeague: sport,
        makerName: takerName,
        makerTeam: takerTeam,
        makerTeamAcronym: findTeamAcronym(takerTeam),
        makerTeamColor: findTeamColor(takerTeam, takerTeamColor),
        makerOutcomePhrase: takerOutcomePhrase.replace(takerTeam, ''),
        takerTeam: makerTeam,
        takerTeamAcronym: findTeamAcronym(makerTeam),
        takerTeamColor: findTeamColor(makerTeam, makerTeamColor),
        makerItems: takerItems,
      };
    }

    return {
      sportLeague: sport,
      makerName,
      makerTeam,
      makerTeamAcronym: findTeamAcronym(makerTeam),
      makerTeamColor: findTeamColor(makerTeam, makerTeamColor),
      makerOutcomePhrase: makerOutcomePhrase.replace(makerTeam, ''),
      takerTeam,
      takerTeamAcronym: findTeamAcronym(takerTeam),
      takerTeamColor: findTeamColor(takerTeam, takerTeamColor),
      makerItems,
    };
  };

  const gamePanelData = getGamePanelData();

  const formatTime = inputTime => {
    const now = new Date();
    const inputDate = new Date(inputTime);

    const msDiff = now - inputDate;
    const hoursDiff = Math.floor(msDiff / (1000 * 60 * 60));
    const daysDiff = Math.floor(msDiff / (1000 * 60 * 60 * 24));

    const isSameDay =
      now.getFullYear() === inputDate.getFullYear() &&
      now.getMonth() === inputDate.getMonth() &&
      now.getDate() === inputDate.getDate();

    if (isSameDay) {
      return `${hoursDiff} hr${hoursDiff !== 1 ? 's' : ''} ago`;
    }
    return `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago`;
  };

  // I think we can get rid of this functionality? Keeping in case we change our mind
  // const openModalWithBetData = (fight, modal) => {
  //   bet.makerOutcomePhrase = formatPhrase();
  //   bet.takerOutcomePhrase = formatPhrase();
  //   msg = formatMsg(msg);
  //   if (sport === 'Specials') {
  //     bet.makerOutcomeTeamColor = findTeamColor(makerTeam, makerTeamColor);
  //     bet.takerOutcomeTeamColor = findTeamColor(takerTeam, takerTeamColor);
  //   } else {
  //     bet.makerOutcomeTeamColor = makerTeamColor;
  //     bet.takerOutcomeTeamColor = takerTeamColor;
  //   }
  //   if (fight.makerOutcomePhrase.includes('FIGHT')) {
  //     let firstNameMaker;
  //     let lastNameMaker;
  //     if (fight.makerOutcomeTeam.split(' ')[1]) {
  //       // eslint-disable-next-line no-unused-vars
  //       [firstNameMaker, lastNameMaker] = fight.makerOutcomeTeam.split(' ');
  //       fight.makerOutcomeTeam = lastNameMaker;
  //     }
  //     let firstNameTaker;
  //     let lastNameTaker;
  //     if (fight.takerOutcomeTeam.split(' ')[1]) {
  //       // eslint-disable-next-line no-unused-vars
  //       [firstNameTaker, lastNameTaker] = fight.takerOutcomeTeam.split(' ');
  //       fight.takerOutcomeTeam = lastNameTaker;
  //     }
  //   } else {
  //     fight.makerOutcomeTeam = makerTeam;
  //     fight.takerOutcomeTeam = takerTeam;
  //     bet.makerTeamAcronym = findTeamAcronym(makerTeam);
  //     bet.takerTeamAcronym = findTeamAcronym(takerTeam);
  //   }
  //   setActiveBet(fight);
  //   if (modal === 'BetDetails') {
  //     setIsBetDetailsOpen(true);
  //   } else if (modal === 'ViewDetails') {
  //     setIsViewDetailsOpen(true);
  //   }
  //   setModalAnimationClass('modal-slide-in');
  // };

  // const handleView = () => {
  //   onViewFight(bet);
  // };

  const closeModal = () => {
    setModalAnimationClass('modal-slide-out');
    setTimeout(() => {
      if (isBetDetailsOpen) {
        setIsBetDetailsOpen(false);
      } else if (isViewDetailsOpen) {
        setIsViewDetailsOpen(false);
      }
      setActiveBet(null);
    }, 500);
  };

  const formatName = fullName => {
    const names = fullName.trim().split(' ');
    if (names.length > 1) {
      return `${names[0]} ${names[names.length - 1][0]}.`;
    }
    return fullName;
  };

  const handleAccept = () => {
    const trySkipToSummary = takerVenueId => {
      if (takerVenueId === bet.restaurantId) {
        fightModalRef?.current?.skipToSummary();
      } else {
        fightModalRef?.current?.present();
      }
    };

    // Allow different venue for delivery fights
    if (bet.takeoutType === TAKEOUT_TYPES.DELIVERY) {
      if (appCtx.restaurant && appCtx.isDelivery) {
        trySkipToSummary(appCtx.restaurant.id);
      } else {
        setOnSelectVenue(() => venue => trySkipToSummary(venue.id));
        setIsPickVenuePopupOpen(true);
      }
    } else {
      fightModalRef?.current?.skipToSummary();
    }
  };

  const handleReject = async itemId => {
    try {
      await rejectFight(bearerToken, itemId);
      if (typeof onFightAction === 'function') {
        onFightAction();
      }
    } catch (error) {
      console.error('Error rejecting fight:', error);
    }
  };

  const handleGoToVenuePage = () => {
    appDispatchCtx.dispatch({
      action: APP_CTX_ACTIONS.SET_ON_SELECT_VENUE,
      payload: venue => {
        onSelectVenue(venue);
        appDispatchCtx.dispatch({
          action: APP_CTX_ACTIONS.SET_ON_SELECT_VENUE,
          payload: null,
        });
      },
    });
    history.push({
      pathname: '/app/restaurant',
      state: { tab: 'delivery' },
    });
    setIsPickVenuePopupOpen(false);
  };

  const content = (
    <div className='live-fight-card' ref={cardRef}>
      <BaseFightCard fight={gamePanelData} tabComponent={`${sport} | ${formatTime(time)}`} />
      {(() => {
        if (!isMaker && pending) {
          return (
            <div className='cols flex-space-between action-buttons-flex card-footer'>
              <IonButton
                fill='clear'
                mode='md'
                className='ion-no-padding action-button life-fights-button-reject'
                onClick={() => handleReject(fightId)}>
                <IonIcon icon={trash} slot='icon-only' />
              </IonButton>

              <IonButton mode='md' className='action-button life-fights-button-accept' onClick={handleAccept}>
                Review
              </IonButton>
            </div>
          );
        }
        if (isMaker && pending) {
          return (
            <div className='card-footer text-button-only'>
              <IonButton
                fill='clear'
                mode='md'
                className='ion-no-padding action-button life-fights-button-reject'
                onClick={() => handleReject(fightId)}>
                <IonIcon icon={trash} slot='icon-only' />
              </IonButton>
            </div>
          );
        }
        if (isAccepted) {
          return (
            <div className='card-footer'>
              <br />
            </div>
          );
        }
        return null;
      })()}
      <TakerFightProcess
        ref={fightModalRef}
        fightData={bet}
        optionalTakerVenue={optionalTakerVenue}
        onAcceptFight={onAcceptFight}
      />
      <TakerError
        isOpen={isPickVenuePopupOpen}
        onClose={() => setIsPickVenuePopupOpen(false)}
        setIsOpen={setIsPickVenuePopupOpen}
        msg='This fight requires you choose a delivery venue.'
        onButtonClick={handleGoToVenuePage}
        buttonText='Go to Venues page'
      />
    </div>
  );

  return (
    <div>
      {content}
      <BetDetailsModal
        bet={activeBet}
        isOpen={isBetDetailsOpen}
        onClose={closeModal}
        formatName={formatName}
        modalAnimationClass={modalAnimationClass}
        pendingFight={1}
      />
      <ViewDetailsModal
        bet={activeBet}
        isOpen={isViewDetailsOpen}
        onClose={closeModal}
        modalAnimationClass={modalAnimationClass}
        formatName={formatName}
        isMaker={isMaker}
      />
    </div>
  );
}

export default LiveFightCard;
